import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useBillingEnabled } from "@hooks";
const PLANS_BILLING_PARAM = "view";
const PLANS_BILLING_VALUE = "plans-billing";
const REPORT_TYPES_VALUE = "report-types";
const CHECKOUT_VALUE = "checkout";
const PlansBillingContext = createContext(undefined);
export const PlansBillingProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedPlan, setSelectedPlan] = useState(undefined);
    const [selectedBillingPeriod, setSelectedBillingPeriod] = useState(undefined);
    const billingEnabled = useBillingEnabled();
    const viewParam = searchParams.get(PLANS_BILLING_PARAM);
    const plansBillingView = viewParam === REPORT_TYPES_VALUE ? "report-types" : viewParam === CHECKOUT_VALUE ? "checkout" : "billing";
    const setPlansBillingView = useCallback((view) => {
        if (!billingEnabled)
            return;
        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            const valueMap = {
                "report-types": REPORT_TYPES_VALUE,
                checkout: CHECKOUT_VALUE,
                billing: PLANS_BILLING_VALUE,
            };
            next.set(PLANS_BILLING_PARAM, valueMap[view]);
            return next;
        });
    }, [billingEnabled, setSearchParams]);
    const contextValue = useMemo(() => ({
        plansBillingView,
        selectedPlan,
        selectedBillingPeriod,
        setPlansBillingView,
        setSelectedPlan,
        setSelectedBillingPeriod,
    }), [
        plansBillingView,
        selectedPlan,
        selectedBillingPeriod,
        setPlansBillingView,
        setSelectedPlan,
        setSelectedBillingPeriod,
    ]);
    return React.createElement(PlansBillingContext.Provider, { value: contextValue }, children);
};
export const usePlansBillingContext = () => {
    const context = useContext(PlansBillingContext);
    if (context === undefined) {
        throw new Error("usePlansBillingContext must be used within a PlansBillingProvider");
    }
    return context;
};
